import { render } from "./TrashIcon.vue?vue&type=template&id=4b46e735"
import script from "./TrashIcon.vue?vue&type=script&lang=js"
export * from "./TrashIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__